module.exports = __webpack_public_path__ + "img/icon(17).be4ccafb.png";